import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import EsmsCard from '../../components/EsmsCard';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import classes from './CommunicationsCard.module.css';

class CommunicationsCard extends Component {
    handlePageRoute = () => {
        const { history } = this.props;

        history.push('/admin/communications' + history.location.search);
    }

    render() {
        let { currentScopes, isLoading } = this.props;
 
        return (
            <EsmsCard
                title="Advanced Communications"
                imagePath="/assets/images/advancedComms-flat.svg"
            >   
                <div className={classes.innerContainer}>
                    {
                        isLoading 
                            ? <div className={classes.topMargin}><CircularProgress /></div> : 
                            <div className={classes.communicationsInfo}>
                                {/* <p>
                                    <span className={classes.label}>Total Clients</span>
                                    <span className={classes.values}>
                                        {clients.length}
                                    </span>
                                </p>
                                <p>
                                    <span className={classes.label}>Enabled Clients</span>
                                    <span className={classes.values}>
                                        {count}
                                    </span>
                                </p> */}
                            </div>
                    }
                    {
                        isAllowed(currentScopes, Permissions('adminFull')) &&
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handlePageRoute}
                        >
                            Manage Advanced Comms
                        </Button>
                    }
                </div>
            </EsmsCard>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentScopes:  state.core.currentScopes,
        clientSettings: state.communications.clientSettingsCache,
    };
};

export default withRouter(connect(mapStateToProps)(CommunicationsCard));

